export const initial_subCategories = {
    client_level_1: [],
    churn_risk: [],
    segment: [],
    visit_days: [0, 1, 2, 3, 4],
    city: [],
};

export const initial_prospect_subCategories = {
    client_level_1: [],
    city: [],
};

export const blankFilters = {
    client_level_1: [],
    churn_risk: [],
    segment: [],
    visit_days: [],
    city: [],
};

export const blankExpandedLevels = {
    client_level_1: true,
    status: true,
    churn_risk: true,
    segment: true,
    visit_days: true,
    city: true,
};

export const blankStatusFilters = {
    is_active: [true],
    is_seasonal: [],
};

export const blankProspectLevels = {
    client_level_1: true,
    status: true,
    city: true,
};

export const blankProspectFilters = {
    client_level_1: [],
    city: [],
};
